<!--搜索-->
<template>
  <div>
    <el-select v-model="searchTypeNew" placeholder="请选择" :style="{width: width, marginRight: '4px'}" @change="postSearchType()">
      <el-option v-for="item in searchTypeList" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
    <el-input type="search" placeholder="请输入内容" :maxlength="searchTypeNew===1?'11':''" v-model="searchValueNew" style="width: 16em;" @blur="postSearchValue()">
      <template #prefix>
        <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
      </template>
    </el-input>
  </div>
</template>

<script>
import { letterNum } from '@/assets/shared/reg-constant'

export default {
  props: {
    searchTypeList: {
      type: Array,
      default: function() {
        return [
          {label : '手机号', value : 1},
          {label : '昵称', value : 2},
          {label : '用户ID', value : 3},
          // {label : '用户日志', value : 4}
        ]
      }
    },
    searchType: {
      type: Number,
      default: 3
    },
    searchValue: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '7.4em'
    }
  },
  data() {
    return {
      searchValueNew: this.searchValue,
      searchTypeNew: this.searchType
    }
  },
  watch: {
    searchValue() {
      this.searchValueNew = this.searchValue
    }
  },
  methods: {
    postSearchType() {
      this.$emit('searchType', this.searchTypeNew);
    },
    postSearchValue() {
      // if(this.searchTypeNew != 2) {
      //   let array = this.searchValueNew.split('');
      //   let arrayTwo = [];
      //   for(let item of array) {
      //     if(letterNum.test(item)) {
      //       arrayTwo.push(item);
      //     }
      //   }
      //   this.searchValueNew = arrayTwo.join('');
      // }
      // this.$emit('searchValue', this.searchValueNew);
      this.$emit('searchValue', this.searchValueNew.replace(/\s*/g,""));
    }
  },
  created() {
    this.$emit('searchType', this.searchTypeNew);
    this.$emit('searchValue', this.searchValueNew);
  }
}

</script>

